import cn from 'classnames';

type ChipsOption<V extends string> = {
  label: string;
  value: V;
  testId?: string;
};

type ChipsProps<V extends string> = {
  options: ChipsOption<V>[];
  value: V;
  onChange: (next: V) => void;
  ariaLabel?: string;
  'data-testid'?: string;
};

export const Chips = <V extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  'data-testid': testId
}: ChipsProps<V>) => (
  <div
    role="radiogroup"
    aria-label={ariaLabel}
    data-testid={testId}
    className="flex items-center gap-2"
  >
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={selected}
          data-testid={option.testId}
          onClick={() => onChange(option.value)}
          className={cn(
            'inline-flex h-9 cursor-pointer items-center justify-center',
            'rounded-full border px-6',
            'text-sm font-medium text-content-primary',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-secondary',
            selected
              ? 'border-action-secondary bg-surface-selected'
              : 'border-border-default hover:bg-surface-muted'
          )}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
